<div class="py-3 d-flex flex-column h-100">
  <div class="container-fluid">
    <h1>{{'COMMON.LABEL.MENU' | translate}}</h1>
  </div>

  <nav class="mt-3 d-flex flex-column flex-grow-1 justify-content-between">
    <mat-nav-list role="navigation">
      <a mat-list-item
        [routerLink]="appSessionService.getTranslatedUrl('investments')"
        routerLinkActive="active-sidenav-link"
        (click)="bitfMatSidenavService.close(null)">
        <mat-icon class="mr-2">trending_up</mat-icon> {{ 'COMMON.LABEL.INVESTMENTS' | translate }}
      </a>
      <a mat-list-item
        [routerLink]="appSessionService.getTranslatedUrl('priceList')"
        routerLinkActive="active-sidenav-link"
        (click)="bitfMatSidenavService.close(null)">
        <mat-icon class="mr-2">format_list_numbered</mat-icon> {{ 'COMMON.LABEL.PRICE_LIST' | translate }}
      </a>
      <!-- <a mat-list-item
        [routerLink]="['/it/veicoli']"
        routerLinkActive="active-sidenav-link"
        (click)="bitfMatSidenavService.close(null)">
        <mat-icon class="mr-2">directions_car</mat-icon> {{ 'COMMON.LABEL.VEHICLES' | translate }}
      </a> -->
      <!-- <a mat-list-item
        [routerLink]="['/it/i-tuoi-investimenti']"
        routerLinkActive="active-sidenav-link"
        (click)="bitfMatSidenavService.close(null)">
        <mat-icon class="mr-2">assignment</mat-icon> {{ 'COMMON.LABEL.YOUR_INVESTMENTS' | translate }}
      </a> -->
      <a mat-list-item
        [routerLink]="appSessionService.getTranslatedUrl('sell')"
        routerLinkActive="active-sidenav-link"
        (click)="bitfMatSidenavService.close(null)">
        <mat-icon class="mr-2">attach_money</mat-icon> {{ 'COMMON.LABEL.SELL' | translate }}
      </a>
      <a mat-list-item
        [routerLink]="appSessionService.getTranslatedUrl('faq')"
        routerLinkActive="active-sidenav-link"
        (click)="bitfMatSidenavService.close(null)">
        <mat-icon class="mr-2">quiz</mat-icon> {{ 'COMMON.LABEL.FAQ' | translate }}
      </a>
      <!-- <a mat-list-item
        [routerLink]="['/it/chi-siamo']"
        routerLinkActive="active-sidenav-link"
        (click)="bitfMatSidenavService.close(null)">
        <mat-icon class="mr-2">people</mat-icon> {{ 'COMMON.LABEL.WHO_WE_ARE' | translate }}
      </a> -->
      <a mat-list-item
        [routerLink]="appSessionService.getTranslatedUrl('contacts')"
        routerLinkActive="active-sidenav-link"
        (click)="bitfMatSidenavService.close(null)">
        <mat-icon class="mr-2">contacts</mat-icon> {{ 'COMMON.LABEL.CONTACTS' | translate }}
      </a>
      <a mat-list-item
        [routerLink]="appSessionService.getTranslatedUrl('newsletter')"
        routerLinkActive="active-sidenav-link"
        (click)="bitfMatSidenavService.close(null)">
        <mat-icon class="mr-2">email</mat-icon> {{ 'COMMON.LABEL.NEWSLETTER' | translate }}
      </a>
    </mat-nav-list>
  </nav>

  <!-- <div class="d-flex align-items-center pl-3">
    <span>{{'COMMON.LABEL.CHANGE_LANGUAGE' | translate }}</span>
    <bitf-mat-language-selector [useShortLabel]="false"></bitf-mat-language-selector>
  </div> -->

  <mat-divider class="my-2">
  </mat-divider>

  <div class="d-flex justify-content-between">
    <a mat-button
      [href]="appSessionService.privacyPolicyUrl"
      target="_blank"
      title="Privacy Policy">Privacy Policy</a>

    <a mat-button
      [href]="appSessionService.cookiePolicyUrl"
      target="_blank"
      title="Cookie Policy ">Cookie Policy</a>
  </div>
</div>